import { render, staticRenderFns } from "./Project16.vue?vue&type=template&id=4333666a&scoped=true&"
import script from "./Project16.vue?vue&type=script&lang=js&"
export * from "./Project16.vue?vue&type=script&lang=js&"
import style0 from "./Project16.vue?vue&type=style&index=0&id=4333666a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333666a",
  null
  
)

export default component.exports